import { BulkLostPackagePage } from "./BulkLostPackagePage";
export default BulkLostPackagePage;
